/* Radiance Veil product gallery (Free People style), 2026-10-25. Styles: assets/rv-product-gallery.css.
   Desktop photo grid: shows 2 rows (4 photos); the round down / up arrows under it slide one row at a time.
   Zooming photos stays the theme's own lightbox. */
(function () {
  'use strict';

  var ROWS = 2;
  var DURATION = 500;

  function visibleItems(media) {
    return Array.prototype.filter.call(media.children, function (el) {
      return el.classList.contains('product__media-item') && !el.classList.contains('hidden') && el.offsetParent !== null;
    });
  }

  // Top of every row (relative to the grid) and the bottom of the last row shown in the window.
  function measure(media) {
    var tops = [];
    var bottoms = {};
    visibleItems(media).forEach(function (item) {
      var top = item.offsetTop;
      if (tops.indexOf(top) === -1) tops.push(top);
      bottoms[top] = Math.max(bottoms[top] || 0, top + item.offsetHeight);
    });
    tops.sort(function (a, b) { return a - b; });
    return { tops: tops, bottoms: bottoms };
  }

  function setup(media) {
    var bar = media.parentElement.querySelector(':scope > [data-rv-gallery-more]');
    if (!bar || !bar.hasAttribute('data-rv-gallery-more')) return;
    if (!media.offsetParent) return; // desktop grid hidden (phone layout)

    media.classList.remove('rv-gallery--ready');
    media.style.removeProperty('--rv-gallery-h');
    var m = measure(media);
    if (m.tops.length <= ROWS) return;

    var first = m.tops[0];
    var height = m.bottoms[m.tops[ROWS - 1]] - first;
    media.__rvGallery = { tops: m.tops, max: m.tops.length - ROWS, index: Math.min(media.__rvGallery ? media.__rvGallery.index : 0, m.tops.length - ROWS) };
    media.style.setProperty('--rv-gallery-h', height + 'px');
    media.classList.add('rv-gallery--ready');
    media.scrollTop = m.tops[media.__rvGallery.index] - first;
    update(media, bar);
  }

  function update(media, bar) {
    var state = media.__rvGallery;
    if (!state) return;
    bar.querySelector('[data-rv-gallery-up]').disabled = state.index <= 0;
    bar.querySelector('[data-rv-gallery-down]').disabled = state.index >= state.max;
  }

  function slide(media, to) {
    var start = media.scrollTop;
    var distance = to - start;
    var began = null;
    if (media.__rvGalleryFrame) cancelAnimationFrame(media.__rvGalleryFrame);
    media.__rvGallerySliding = true;
    function step(now) {
      if (began === null) began = now;
      var t = Math.min(1, (now - began) / DURATION);
      var eased = 1 - Math.pow(1 - t, 3); // ease-out
      media.scrollTop = start + distance * eased;
      if (t < 1) media.__rvGalleryFrame = requestAnimationFrame(step);
      else media.__rvGallerySliding = false;
    }
    media.__rvGalleryFrame = requestAnimationFrame(step);
  }

  function go(button, direction) {
    var bar = button.closest('[data-rv-gallery-more]');
    var media = bar && bar.parentElement.querySelector(':scope > .product__media[data-rv-gallery-slider]');
    if (!media || !media.__rvGallery) return;
    var state = media.__rvGallery;
    var next = Math.max(0, Math.min(state.max, state.index + direction));
    if (next === state.index) return;
    state.index = next;
    slide(media, state.tops[next] - state.tops[0]);
    update(media, bar);
  }

  function setupAll() {
    document.querySelectorAll('[data-rv-gallery-slider]').forEach(setup);
  }

  document.addEventListener('click', function (event) {
    var up = event.target.closest('[data-rv-gallery-up]');
    var down = event.target.closest('[data-rv-gallery-down]');
    if (up) go(up, -1);
    if (down) go(down, 1);
  });

  // The theme's own variant scroll (scrollIntoView) can move the window; keep the arrows in step.
  document.addEventListener('scroll', function (event) {
    var media = event.target;
    if (!media || !media.__rvGallery || media.__rvGallerySliding) return;
    var state = media.__rvGallery;
    var offset = media.scrollTop + state.tops[0];
    var nearest = 0;
    state.tops.forEach(function (top, i) {
      if (i <= state.max && Math.abs(top - offset) < Math.abs(state.tops[nearest] - offset)) nearest = i;
    });
    state.index = nearest;
    update(media, media.parentElement.querySelector(':scope > [data-rv-gallery-more]'));
  }, true);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(setupAll, 150);
  });
  window.addEventListener('load', setupAll);

  // Picking a color with its own photos re-renders the gallery (theme fetches the section again).
  function watch() {
    document.querySelectorAll('.product__primary-left').forEach(function (left) {
      if (left.__rvGalleryWatch) return;
      left.__rvGalleryWatch = new MutationObserver(function () {
        clearTimeout(left.__rvGalleryTimer);
        left.__rvGalleryTimer = setTimeout(setupAll, 50);
      });
      left.__rvGalleryWatch.observe(left, { childList: true });
    });
  }

  /* ---------- start ---------- */

  function start() {
    setupAll();
    watch();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
